import styled, { DefaultTheme, ThemeProps, css } from 'styled-components';

const ListItemModifiers = {
  blockListTemplate: ({ theme }: ThemeProps<DefaultTheme>) => css`
    padding: ${theme.spacing.km4} 0;
    border-bottom: ${theme.color.border.neutral.default}
      ${theme.border.style.solid} ${theme.border.width.thinner};
    border-radius: 0;
    min-height: 92px;
    position: relative;
  `,
};

export const ListItem = styled.li<{
  active?: boolean;
  blockListTemplate?: boolean;
}>`
  ${({ theme, active, blockListTemplate }) => css`
    cursor: pointer;
    display: flex;
    color: ${theme.color.text.neutral.default};
    line-height: ${theme.font.lineHeight.medium};
    padding: ${`${theme.spacing.km3} ${theme.spacing.km4}`};
    border-radius: ${theme.border.radius.medium};

    &:hover {
      background: ${theme.color.background.neutral.weak};
    }

    ${blockListTemplate && ListItemModifiers.blockListTemplate({ theme })}
    ${active && `background: ${theme.color.background.neutral.weak};`}
  `}
`;

export const LeftIconContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${theme.icon.small};
    color: ${theme.color.text.neutral.strong};
  `}
`;

export const Description = styled.div`
  ${({ theme }) => css`
    font-weight: ${theme.font.weight.medium};
    width: 100%;
  `}
`;

export const RightIconContainer = styled(LeftIconContainer)`
  margin-left: auto;
`;
